import {Form, Input, notification, Space, Typography} from "@ui";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {PrimaryButton} from "@/components/Button";
import useIsMobile from "@/hooks/useIsMobile";
import useRecoverPassword from "../../../hooks/useRecoverPassword";
import {useAuthStore} from "../../../store/useAuth.store";
import {useUserSupport} from "../../../store/useUserSupport.store";
import {useLogo} from "../../../util/logoUtils";
import styles from "./RecoverPassword.module.css";

const LoginForm = () => {
  const logo = useLogo(); // Dynamic logo based on hostname

  const {requestPassword, isSuccess, isError, isPending} = useRecoverPassword();

  const {t} = useTranslation();
  const isTablet = useIsMobile({breakpoint: 920});

  const handleAuthForm = useAuthStore(state => state.handleAuthForm);
  const handleSupportModal = useUserSupport(state => state.handleSupportModal);

  const onFinish = values => {
    requestPassword(values.username);
  };
  const onFinishFailed = _errorInfo => {};

  useEffect(() => {
    if (isSuccess) {
      notification.success({
        message: t("loginPasswordRecover"),
        description: t("loginPasswordRecoverMsg"),
      });
    }
  }, [isSuccess, isError]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "auto",
      }}
    >
      <img
        src={logo}
        alt="logo"
        style={
          !isTablet
            ? {width: "180px", height: "140px", display: "block", margin: "0 auto 24px auto", marginTop: "24px"}
            : {width: "120px", height: "90px", display: "block", margin: "0 auto 16px auto", marginTop: "24px"}
        }
      />
      <Form
        name="basic"
        className={styles.form_container_password}
        initialValues={{remember: true}}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        layout="vertical"
      >
        <Form.Item className={styles.form_container_password_form}>
          <h3 style={{fontSize: "1.5rem", display: "flex", alignItems: "center", justifyContent: "center"}}>
            {t("loginPasswordRecoverTitle")}
          </h3>
          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: t("loginUserName"),
              },
            ]}
            style={{width: "100%"}}
          >
            <Input
              placeholder={t("loginEmailPlaceholder")}
              className={styles.Input}
            />
          </Form.Item>

          <Form.Item style={{textAlign: "center"}}>
            <PrimaryButton
              style={{width: "80%"}}
              htmlType="submit"
              loading={isPending}
            >
              {t("loginSendBtn")}
            </PrimaryButton>
          </Form.Item>

          <Form.Item style={{textAlign: "center"}}>
            <Space size="middle">
              <Typography.Text
                onClick={() => handleAuthForm("login")}
                className={styles.hover_recover_password}
              >
                {t("loginSessionTitle")}
              </Typography.Text>
              <Typography.Text className={styles.hover_recover_password}>
                {t("loginNoAccount")}
                <Typography.Link
                  href="/signup"
                  className={styles.hover_recover_link}
                >
                  {" "}
                  {t("loginRegister")}
                </Typography.Link>
              </Typography.Text>
            </Space>
            <p className={styles.hover_recover_support}>
              {t("loginRecoverEmail")}{" "}
              <Typography.Link
                className={styles.hover_recover_link}
                onClick={() => {
                  handleSupportModal(true);
                }}
                style={{cursor: "pointer"}}
              >
                {t("loginSupport")}
              </Typography.Link>
            </p>
          </Form.Item>
        </Form.Item>
      </Form>
    </div>
  );
};

export default LoginForm;
